export default {"src":"/_next/static/media/password-done.19d32fde.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};